import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

/**
 * @author weiztang
 * @version 0.0.1
 * @date 2022.09.20
 * @class biz/pcShare/qzoneShare
 */
import loader from '../../common/loader';
import './qzone.css'; // 迁移和去jquery化来自milo.js

var qzoneShare = {
  defopt: {
    origin: "".concat(location.protocol, "//").concat(location.host),
    // 调用方页面的域名和协议，一定要一致，否则会调用失败
    url: window.location.href,
    title: document.title,
    desc: '',
    pics: '',
    summary: document.title,
    // 默认初始化为
    site: '',
    showcount: '1',
    // 1默认显示
    md: '1',
    // 1默认不允许更改
    where: 10
    /* 这个写死，不要改*/
    ,
    qc: 1
    /* 这个写死，不要改*/
    ,
    callback: null
  },
  share: function share(opt) {
    var _self = this;

    _self.defopt = _objectSpread(_objectSpread({}, this.defopt), opt);

    if (document.getElementById('milo_qzone_share')) {
      console.log('Milo:当前已有Qzone分享拉起，忽略调用');
      return;
    }

    var tpl = "<div id=\"milo_qzone_share_title\">\n      <span>\u5206\u4EAB\u5230Qzone</span>\n      <a href=\"javascript:;\" title=\"\u5173\u95ED\" id=\"milo_qzone_share_close\">\u5173\u95ED</a>\n    </div>\n    <div id=\"milo_qzone_share_content\">\n    </div>";
    var divContent = document.createElement('div');
    divContent.id = 'milo_qzone_share';
    divContent.innerHTML = tpl;
    document.body.appendChild(divContent);
    loader.loadScript('https://qzonestyle.gtimg.cn/qzone/app/qzshare/script/qzshare.onekey.co.js').then(function () {
      var successNoteId = 'milo_qzone_share_succ';
      var succContent = document.createElement('div');
      succContent.id = successNoteId;
      succContent.style = 'position:fixed;width:150px;height:40px;left:50%;top:50%;margin-left:-75px;margin-top:-20px;line-height:40px;font-size:18px;background-color:grey;color:white;text-align:center;border-radius:5px;display:none;z-index:1000000;';
      document.body.appendChild(succContent);
      var option = _self.defopt;
      var newId = 0;
      window.miloQzoneShareIsCallbacked = false;
      var iframeUrl = 'https://sns.qzone.qq.com/cgi-bin/qzshare/cgi_qzshare_onekey?';
      var paramsArr = [];

      for (var k in option) {
        if ('callback' != k) {
          paramsArr.push("".concat(k, "=").concat(encodeURIComponent(option[k])));
        }
      }

      iframeUrl += paramsArr.join('&');
      newId = "shareIframe_".concat(Math.ceil(Math.random() * 10000000)); // 降域

      document.domain = 'qq.com'; // 在iframe创建之前调用，切记

      QZONE.shareCrossOriginHandler.init({
        iframeId: newId,
        // 嵌入分享页的iframe的id
        onShareSuccess: function onShareSuccess(shareid) {
          // 分享成功的回调函数
          if (window.miloQzoneShareIsCallbacked) {
            return;
          }

          console.log('Milo:Qzone share success');
          window.miloQzoneShareIsCallbacked = true; // 设标识位，callback只能被调用一次

          var tipsDom = document.getElementById(successNoteId);
          tipsDom.style.display = 'block';
          tipsDom.innerText = 'Qzone分享成功';

          if (_self.defopt.callback && 'function' === typeof _self.defopt.callback) {
            _self.defopt.callback.call(null, shareid);
          }
        }
      });
      var iframe = document.createElement('iframe');
      iframe.src = iframeUrl;
      iframe.id = newId;
      iframe.width = '800px';
      iframe.height = '440px';
      iframe.frameborder = 0;
      iframe.style = 'border:none;overflow:hidden;';
      document.getElementById('milo_qzone_share_content').appendChild(iframe);
      document.getElementById('milo_qzone_share_close').addEventListener('click', function () {
        document.body.removeChild(document.getElementById('milo_qzone_share'));
        document.body.removeChild(document.getElementById(successNoteId));
        window.miloQzoneShareIsCallbacked = false;
      });
    });
  }
};
export default {
  qzoneShare: qzoneShare
};